import { type ServiceConfig } from '../../ServiceRegistry';
import BaseService from '@/services/BaseService';
import CollateralProcessorService from '@/services/CollateralProcessorService';

/**
 * Collateral service configurations
 * These services are used by the collateral module
 */
export const collateralServices: ServiceConfig[] = [
  {
    name: 'collateralBaseService',
    factory: () => new BaseService('/api/collateral'),
  },
  {
    name: 'collateralAssetService',
    factory: () => new BaseService('/api/collateral/assets'),
  },
  {
    name: 'collateralValuationService',
    factory: () => new BaseService('/api/collateral/valuations'),
  },
  {
    name: 'collateralMonitoringService',
    factory: () => new BaseService('/api/collateral/monitoring'),
  },
  {
    name: 'collateralProcessorService',
    factory: () => new CollateralProcessorService(),
  },
];

/**
 * Collateral-specific service factory
 * Creates a custom service with collateral-specific configuration
 */
export const createCollateralCustomService = (
  serviceName: string,
  baseUrl: string = '/api/collateral',
): ServiceConfig => ({
  name: serviceName,
  factory: () => new BaseService(baseUrl),
});

/**
 * Collateral service utilities
 */
export const collateralServiceUtils = {
  /**
   * Get all collateral service names
   */
  getServiceNames: () => collateralServices.map(s => s.name),

  /**
   * Check if a service name is a collateral service
   */
  isCollateralService: (name: string) => collateralServices.some(s => s.name === name),

  /**
   * Get collateral base path
   */
  getBasePath: () => '/securitization/collateral',
};
